import { ErrorBoundary } from '@onwardtravelsolutions/package-react/Components';
import { NoticeType } from '@onwardtravelsolutions/package-react/Enums';
import { Notice } from '@onwardtravelsolutions/package-react/Types';
import { generateUuid } from '@onwardtravelsolutions/package-react/Utilities/strings';
import { NoticeList } from '../Notices';

type NoticeErrorBoundaryProps = {
    children: React.ReactNode;
    notice?: Notice;
};

export default function NoticeErrorBoundary({
    children,
    notice = {
        title: 'An unknown error has occurred.',
        body: 'Please try again later.',
        type: NoticeType.Error,
        uid: generateUuid(),
    },
}: NoticeErrorBoundaryProps) {
    return (
        <ErrorBoundary
            fallback={<NoticeList id='form-errors' notices={[notice]} />}
        >
            {children}
        </ErrorBoundary>
    );
}
